<template>
  <div class="pagenavi">
    과거 신고자료를 직접 제출하실 경우에는, 홈택스에 어린이집 인증서로 로그인 후
    <br /><br />
    원천징수이행상황신고서를 아래의 경로를 통해 조회한 후 
    <br /><br />
    월별(1월~서비스 이용 전 신고월까지) 신고서를 pdf 파일로 다운로드하여 제출해 주시기 바랍니다.
    <br /><br /><br /><br />
    <b>※  원천징수이행상황신고서 다운로드 경로</b>
    <br /><br />
    홈택스 > 인증서로그인 > 나의 홈택스 > 세금신고 > 세금신고내역 > 원천세 선택 > 신고일자(1월~조회월) > 조회
    <br /><br />
    조회된 월별 신고 목록에서 귀속년월별 > 신고서 보기 > 출력하기 > 인쇄방식 PDF선택 후 인쇄 > PDF로 저장 > 세로이에 제출
  </div>
  <div v-if="props.prsntAt" class="layer-btn">
    <btn :txt="'파일 다시 제출하기'"
         :color="'purple'"
         @click="btnRgst_click"/>
  </div>
  <div v-else class="layer-btn">
    <btn :txt="'다음에 하기'"
         :color="'white'"
         @click="btnCancl_click"/>
    <btn :txt="'제출하기'"
         :color="'purple'"
         @click="btnRgst_click"/>
  </div>
</template>

<script setup>
import {defineProps, defineEmits} from "vue";
import {getUtils} from "@/utils/import";
const {$alert} = getUtils();

const props = defineProps({
  prsntAt: {
    type: Boolean,
    required: true
  }
})
const emits = defineEmits(['rgst', 'close']);

const btnCancl_click = () => {
  $alert('과거 신고자료를 제출하여, 당해 연도에 신고한 원천세 신고자료에 대한 오류검증을 진행합니다. <br /><br /> 다음에 하실 경우에는 포털 > 시설/서비스 > 서비스신청내역 > [과거세무신고자료]에서 제출 가능합니다.')
  emits('close');
}

const btnRgst_click = async () => {
  emits('rgst');
  emits('close');
}
</script>

<style scoped>

</style>
